import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from "@angular/common/http";


// import decode from 'jwt-decode';
// import * as JWT from 'jwt-decode';

import { JwtHelperService } from '@auth0/angular-jwt';


const helper = new JwtHelperService();
@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {

  base_uri: string;
  // decodedToken;
  // public login: Login;


  constructor(private http: HttpClient) {
    this.base_uri = environment.auth_uri;
    // this.decodedToken = this.getDecodedToken();
  }


  login(data) {
    return this.http.post(this.base_uri + 'user/authenticate', data);
    // headers: new HttpHeaders().set('Authorization', this.authService.getToken())
  }

  googleLogin(data){
    return this.http.post(this.base_uri + 'user/authenticate-google', data);
  }

  verifyOtp(data){
    return this.http.post(this.base_uri + 'user/verify-otp', data);
  }

  recoverPassword(data) {
    return this.http.post(this.base_uri + 'user/reset-password', data);
  }



  changePassword(data) {
    return this.http.post(this.base_uri + 'user/forget-password', data);
  }


  getToken() {
    return localStorage.getItem('token');
  }


  setToken(token) {
    localStorage.setItem('token', token);
    sessionStorage.setItem('token',token);
  }


  getDecodedToken() {
    let token = localStorage.getItem('token');
    let data;
    if (token) {
      data = helper.decodeToken(token);
    }
    return data;
  }


  isTokenExpired() {
    let isTokenExpired = true;
    let token = localStorage.getItem('token');
    if (token && token !== 'null' && token !== 'undefined') {
      isTokenExpired = helper.isTokenExpired(token);
      // console.log(isTokenExpired);

    }

    //If there is no token then also the route should be protected.
    return isTokenExpired;
  }


  logout() {
    localStorage.clear();
  }


  getMe() {
    return this.http.get(this.base_uri + 'hospital/staff/me', {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getToken())
    });
  }


  uploadDP(data) {
    return this.http.put(this.base_uri + 'user/dp', data, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getToken()),
    });
  }



  createStaff(data) {
    let decodedToken = this.getDecodedToken();


    data.created_by = decodedToken['user'];
    //Add hospital to payload
    data.hospital = decodedToken['hospital'];
    // console.log(data);

    return this.http.post(this.base_uri + 'user/', data, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getToken()),
    });
  }


  getStaff(role?) {
    let decodedToken = this.getDecodedToken();

    //Add hospital to payload
    let hospital = decodedToken['hospital'];
    let url = this.base_uri + 'user/staff?hospital=' + hospital;
    if (role) {
      url += '&role=' + role;
    }

    return this.http.get(url, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getToken()),
    });
  }

  getOrganizationStaff(role?, page?, items?) {
    let decodedToken = this.getDecodedToken();
    let hospital = decodedToken['hospital'];
    let url = this.base_uri + 'user/organization/staff?hospital=' + hospital;
    
    //Add hospital to payload
    if (role) {
      url += '&role=' + role;
    }
    if (page) {
      url += '&page=' + page;
    }
    if (items) {
      url += '&items=' + items;
    }

    return this.http.get(url, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getToken()),
    });
  }

  getRoles(organization_type){
    let decodedToken = this.getDecodedToken();

    let hospital = decodedToken['hospital'];
    let url = this.base_uri + 'role?organization_type=' + organization_type;

    return this.http.get(url, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getToken()),
    });
  }


  updateStaff(data){
    let decodedToken = this.getDecodedToken();


    data.updated_by = decodedToken['user'];
    //Add hospital to payload
    data.hospital = decodedToken['hospital'];
    // console.log(data);

    return this.http.put(this.base_uri + 'user/', data, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getToken()),
    });
  }

  getUserRelations(){
    let decodedToken = this.getDecodedToken();

    let url = this.base_uri + 'user/relation/get_relation';

    return this.http.get(url, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getToken()),
    });
  }

  /** Landing page key configured for the logged-in staff member (that column only). */
  getLandingPage(){
    return this.http.get(this.base_uri + 'user/landing-page', {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.getToken()),
    });
  }
}
